import Const from '@/helpers/const'
import { API, graphqlOperation } from '@aws-amplify/api'
import { getLearningObject } from '@/graphql/queries'
import { customSearchLearningObjects } from '@/graphql/searchQueries'

export default {
  getLearningObjectById(id) {
    return API.graphql(graphqlOperation(getLearningObject, { id }))
      .then(result => {
        return Promise.resolve(result.data.getLearningObject)
      })
      .catch(e => {
        return Promise.reject(e)
      })
  },

  searchLearningObjects(type, query = '', area = '', limit = 1000, nextToken = '') {
    let params = {
      limit,
      sort: {
        field: 'title',
        direction: 'asc'
      }
    }
    let filter = {}
    if (nextToken)
      params.nextToken = nextToken
    if (query) {
      filter.or = [
        {
          title: {
            matchPhrasePrefix: query
          }
        },
        {
          description: {
            matchPhrasePrefix: query
          }
        },
        {
          course: {
            matchPhrasePrefix: query
          }
        },
        {
          code: {
            matchPhrasePrefix: query
          }
        },
      ]
    }
    if (area) {
      filter.areaNames = {
        eq: area
      }
    }
    if (type) {
      filter.type = {
        eq: type
      }
    }
    if (Object.keys(filter).length)
      params.filter = filter
    return API.graphql(graphqlOperation(customSearchLearningObjects, params))
      .then(result => {
        return Promise.resolve(result.data.searchLearningObjects)
      })
      .catch(e => {
        return Promise.reject(e)
      })
  },
}